import { ICommonResponse } from 'api/types';
import { IEntity } from 'types';
import { getAcademicYearByDate, getAcademicYearsByPeriod, isDateValid } from 'utils';

import { splittedDataToSortedArray } from './splittedDataToSortedArray';

export const splitEntitiesByAcademicYear = (data: ICommonResponse<IEntity>, academicYears: string[]) => {
  const learningYearData: Record<string, IEntity[]> = {};

  data.content.forEach((item) => {
    let periods: string[] = [];
    if (item.formData.startDate && item.formData.endDate) {
      const startDate = new Date(item.formData.startDate);
      const endDate = new Date(item.formData.endDate);
      if (startDate && endDate) {
        periods = getAcademicYearsByPeriod(startDate, endDate);
      }
    } else {
      const date = item.formData.startDate ? new Date(item.formData.startDate) : new Date(item.formData.endDate);

      if (isDateValid(date)) {
        periods.push(getAcademicYearByDate(date));
      }
    }

    periods.forEach((period) => {
      if (academicYears.includes(period)) {
        if (learningYearData[period]) {
          learningYearData[period].push(item);
        } else {
          learningYearData[period] = [item];
        }
      }
    });
  });

  return splittedDataToSortedArray(learningYearData);
};
